/**
 * Downloads the given data blob (Blob) as a file with the given filename using a programmatic click
 * on a dynamically generated and removed link.
 *
 * @param {Blob} dataBlob
 * @param {String} filename
 */
const downloadBlob = function(dataBlob, filename) {
	// Create temp link element
	const link = document.createElement("a");
	link.setAttribute("href", URL.createObjectURL(dataBlob));
	link.setAttribute("download", filename);
	document.body.appendChild(link);

	// Trigger the download
	link.click();

	// Clean up
	document.body.removeChild(link);
};

module.exports = {
	downloadBlob,
};
